module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"binaryLinkTitle":"Soubor byl odeslán. Klikněte pro stažení."},"de":{"binaryLinkTitle":"Datei wurde übermittelt. Klicken Sie, um sie herunterzuladen."},"es":{"binaryLinkTitle":"El archivo fue enviado. Haga clic para descargar."},"fr":{"binaryLinkTitle":"Le fichier a été soumis. Cliquez pour le télécharger."}}')
  delete Component.options._Ctor
}
